<i18n>
{
  "ru":{
    "statistic": "Статистика за период",
    "submit": "Сформировать",
    "statistic_invoice_title": "Общая статистика по счетам",
    "today_invoices": "Счета за сегодня",
    "statistic_currency_title": "Статистика по платежам",
    "currencies": "Курсы валют (НБ РБ)",
    "all_currencies": "Все валюты",
    "paid_invoices": "Оплаченные счета",
    "due_invoices": "Ожидающие счета",
    "overdue_invoices": "Просроченные счета",
    "total_invoices": "Всего счетов",
    "not_available": "Данные отсутствуют",
    "cards_stat": "Доли карт",
    "statistic_nodata": "За выбранный период данных нет"
  },
  "en":{
    "statistic": "Statistic",
    "submit": "Submit",
    "statistic_invoice_title": "Total invoice statistics",
    "today_invoices": "Today invoices",
    "statistic_currency_title": "Statistic for transactions",
    "currencies": "Currencies (NBRB)",
    "all_currencies": "All currencies",
    "paid_invoices": "Paid invoices",
    "due_invoices": "Due invoices",
    "overdue_invoices": "Overdue invoices",
    "total_invoices": "Total invoices",
    "not_available": "Not available",
    "cards_stat": "Cards percentage",
    "statistic_nodata": "There is no data for selected range"
  }
}
</i18n>
<template>
  <div v-loading="loading">
    <invoice-modal
      v-if="showInvoiceModal"
      :visible.sync="showInvoiceModal"
      :callback="invoiceCreated"
    />

    <el-row>
      <el-card>
        <el-form
          :model="filter"
          ref="filter"
          :rules="filterRules"
          @submit.native.prevent="getStatistic()"
          :inline="true"
        >
          <input class="hidden-input" ref="hidden" />
          <el-form-item :label="$t('statistic') + ' ' + $t('from')" prop="date_from">
            <el-date-picker
              size="medium"
              v-model="filter.date_from"
              @change="$refs['hidden'].focus()"
              type="date"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('to')" prop="date_to">
            <el-date-picker
              size="medium"
              v-model="filter.date_to"
              @change="$refs['hidden'].focus()"
              type="date"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button round plain type="primary" native-type="submit">
              {{
              $t('submit')
              }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-row>

    <el-row :gutter="20" v-if="data">
      <el-col :sm="24" :md="12">
        <el-card>
          <h2 class="dashboard--panel-title">
            {{
            $t(todayInvoices ? 'today_invoices' : 'statistic_invoice_title')
            }}
          </h2>
          <el-row :gutter="20">
            <el-col :sm="12" class="dashboard_invoice_wrap">
              <img src="../invoices/img/invoice-ok.svg" alt />
              <h3 class="dashboard_invoice_title">{{ $t('paid_invoices') }}:</h3>
              <span class="dashboard_invoice_descroption">
                {{
                data.paidinv + data.pendinginv
                }}
              </span>
            </el-col>
            <el-col :sm="12" class="dashboard_invoice_wrap">
              <img src="../invoices/img/invoice-time.svg" alt />
              <h3 class="dashboard_invoice_title">{{ $t('due_invoices') }}:</h3>
              <span class="dashboard_invoice_descroption">
                {{
                data.dueinv
                }}
              </span>
            </el-col>
            <el-col :sm="12" class="dashboard_invoice_wrap">
              <img src="../invoices/img/invoice-err.svg" alt />
              <h3 class="dashboard_invoice_title">{{ $t('overdue_invoices') }}:</h3>
              <span class="dashboard_invoice_descroption">
                {{
                data.overdueinv
                }}
              </span>
            </el-col>
            <el-col :sm="12" class="dashboard_invoice_wrap">
              <img src="../invoices/img/invoice.svg" alt />
              <h3 class="dashboard_invoice_title">{{ $t('total_invoices') }}:</h3>
              <span class="dashboard_invoice_descroption">{{ totalInv }}</span>
            </el-col>
            <el-col :sm="24" align="right" class="dashboard_invoice_wrap">
              <router-link :to="{ name: 'invoices' }">
                <el-button round type="info" plain>
                  {{
                  $t('invoices')
                  }}
                </el-button>
              </router-link>
              <el-button
                round
                plain
                type="primary"
                v-if="canAddInvoice"
                @click.prevent="newInvoice()"
              >{{ $t('new_invoice') }}</el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card>
          <el-row>
            <h2 class="dashboard--panel-title">{{ $t('cards_stat') }}</h2>
          </el-row>
          <pie-chart v-if="data.card_stat" :dict="data.card_stat"></pie-chart>
          <el-row class="aligner" v-if="!data.card_stat">
            {{
            $t('not_available')
            }}
          </el-row>
        </el-card>
      </el-col>

      <el-col :sm="24" :md="12">
        <el-card v-if="data.rates">
          <h2 class="dashboard--panel-title">{{ $t('currencies') }}</h2>
          <el-row>
            <span v-for="(value, key) in data.rates" :key="key" class="inline">
              {{ key }} - {{ value.rate }}
              <span
                class="rate_scale"
                v-if="value.scale != 1"
              >({{ value.scale }})</span>
            </span>
          </el-row>
        </el-card>

        <!-- Payment statistics block -->
        <el-card>
          <el-row>
            <el-col :sm="16">
              <h2 class="dashboard--panel-title">{{ $t('statistic_currency_title') }}:</h2>
            </el-col>
            <el-col :sm="8" v-if="paymentStatistic">
              <el-form>
                <el-form-item>
                  <el-select size="mini" v-model="selectedCurr">
                    <el-option v-for="curr in currList" :key="curr" :label="$t(curr)" :value="curr"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row class="aligner ma-3" v-if="!paymentStatistic">
            {{
            $t('statistic_nodata')
            }}
          </el-row>
          <statistic v-if="st" :st="st"></statistic>
          <div v-if="selectedCurr && !st">
            <el-row v-for="curr in currList" :key="curr">
              <statistic v-if="data.stat[curr]" :st="data.stat[curr]"></statistic>
            </el-row>
          </div>
          <div v-if="paymentStatistic">
            <router-link :to="{ name: 'payments' }">
              <el-button round plain type="info">
                {{
                $t('payments')
                }}
              </el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import PieChart from '../../core/PieChart'
import InvoiceModal from '../invoices/InvoiceModal'
import Statistic from './Statistic'

export default {
  name: 'dashboard',
  components: {
    'pie-chart': PieChart,
    'invoice-modal': InvoiceModal,
    statistic: Statistic
  },
  data: () => ({
    filterRules: {
      date_from: { required: true, trigger: 'blur', message: ' ' },
      date_to: { required: true, trigger: 'blur', message: ' ' }
    },
    filter: {
      date_from: null,
      date_to: null,
      currency_id: -1,
      submit: 'Подтвердить'
    },

    data: null,

    currList: null,
    selectedCurr: null,

    loading: false,
    todayInvoices: false,
    showInvoiceModal: false,
    canAddInvoice: !!apiRes.addInvoiceUrl,
    day: 1000 * 60 * 60 * 24
  }),
  mounted() {
    this.filter.date_to = new Date()
    this.filter.date_from = new Date(+this.filter.date_to - this.day)
    this.loading = true
    if (apiRes.statisticUrl) {
      setTimeout(() => {
        this.getStatistic()
      }, 1000)
    } else {
      this.$router.push({ name: 'invoices' })
    }
  },
  methods: {
    withoutTime(date) {
      var d = new Date(date)
      d.setHours(0, 0, 0, 0)
      return d
    },
    getStatistic() {
      if (this.$refs['filter']) {
        this.$refs['filter'].validate(valid => {
          if (valid) {
            let today = this.withoutTime(new Date()).getTime()
            this.todayInvoices =
              this.withoutTime(this.filter.date_to).getTime() === today &&
              today - this.withoutTime(this.filter.date_from) === this.day
            this.loading = true

            apiRes
              .post(apiRes.statisticUrl, this.filter)
              .then(data => {
                if (!data.page_vars.stat) data.page_vars.stat = []
                if (!data.page_vars.dueinv) data.page_vars.dueinv = 0
                if (!data.page_vars.overdueinv) data.page_vars.overdueinv = 0
                if (!data.page_vars.paidinv) data.page_vars.paidinv = 0
                if (!data.page_vars.pendinginv) data.page_vars.pendinginv = 0
                this.currList = ['all_currencies'].concat(
                  Object.keys(data.page_vars.stat)
                )
                if (this.currList.length) {
                  this.data = data.page_vars
                  this.selectedCurr = this.currList[0]
                } else {
                  this.$alert(this.$t('search_no_results'), '', {
                    type: 'warning'
                  })
                }

                this.loading = false
              })
              .catch(() => {
                this.$notify.error({
                  title: this.$t('error'),
                  message: ''
                })
                this.loading = false
              })
          }
        })
      }
    },
    newInvoice() {
      this.showInvoiceModal = true
    },
    invoiceCreated() {
      if (this.todayInvoices) {
        this.loadInvoices()
      }
    }
  },
  computed: {
    st: {
      get() {
        return this.data && this.data.stat && this.selectedCurr
          ? this.data.stat[this.selectedCurr]
          : null
      }
    },
    paymentStatistic: {
      get() {
        return this.currList && this.currList.length > 1
      }
    },
    totalInv() {
      let total =
        parseInt(this.data.paidinv) +
        parseInt(this.data.pendinginv) +
        parseInt(this.data.dueinv) +
        parseInt(this.data.overdueinv)
      return isNaN(total) ? 0 : total
    }
  }
}
</script>

<style scoped>
.dashboard--panel-title {
  font-family: "Roboto", sans-serif;
  font-size: 1.2em;
  border-bottom: 3px solid #00abec;
  padding-bottom: 5px;
  display: inline;
  font-weight: lighter;
}

.dashboard_invoice_wrap {
  margin-top: 20px;
}

.dashboard_invoice_wrap img {
  width: 46px;
  float: left;
  padding: 10px;
}

.dashboard_invoice_title {
  color: #6d8b97;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  padding: 0 !important;
  margin: 15px 0 0;
}

.dashboard_invoice_descroption {
  color: #6d8b97;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
}

.statistic_pay_header {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  padding-bottom: 0;
  margin-bottom: 10px;
  display: block;
  height: 32px;
}

.statistic_payments_wrap > div > div {
  border-bottom: 1px solid #f0f0f0;
}

.spatistic_pay_sum {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  color: #333333;
  text-align: center;
  padding-top: 0;
  margin-top: 0;
}

.spatistic_pay_sum span {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #6d8b97;
  text-transform: uppercase;
  margin-left: 6px;
}

.rate_scale {
  font-size: 10px;
  color: #999;
  vertical-align: middle;
}
</style>
